export default "__VITE_ASSET__DkjVy14h__"